import React from 'react';
import logo from './../../images/lnb_logo.png'

class HeaderNavi extends React.Component{
    constructor (props) {
        super(props);
        this.state = {
            didScroll : 0,
            scrolling : false
        };
        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    handleScroll(event) {
        if (window.scrollY < 1  || window.scrollY < this.state.didScroll) {
            this.setState({scrolling: false});
        } else {
            this.setState({scrolling: true});
        }
        this.setState({didScroll: window.scrollY});
        // console.log(window.scrollY);
    }

    render(){
        return (
            <div className={this.state.scrolling ? 'header-navi' : 'header-navi-fixed'}>
                <div className="navi-contents">
                    <a href="https://cafielo.github.io/MeongCaWeb/">
                        <div className="logo">
                            <div><img src={logo} /></div>
                            <div><p>{this.props.title}</p></div>
                        </div>
                    </a>
                    <div className="menu">NAPLAB</div>
                </div>
            </div>
        )
    }
}  
        
export default HeaderNavi;


// WEBPACK FOOTER //
// ./src/components/header/HeaderNavi.js